import http from "./http.config";

export const fetchMessages = (params = {}) =>
  http.get("/messages", { params }).then((res) => res.data);

export const fetchCustomerMessages = (params = {}) =>
  http.get("/customers/messages", { params }).then((res) => res.data);

export const fetchVendorMessages = (params = {}) =>
  http.get("/vendors/messages", { params }).then((res) => res.data);

export const fetchConversationMessages = (id: string | number, params = {}) =>
  http.get(`/messages/${id}`, { params }).then((res) => res.data);

export const fetchCustomerMessageDetail = (id: string | number, params = {}) =>
  http.get(`/customers/messages/${id}/details`, { params }).then((res) => res.data);

export const fetchVendorMessageDetail = (id: string | number, params = {}) =>
  http.get(`/vendors/messages/${id}/details`, { params }).then((res) => res.data);

export const sendMessage = (id: string | number, payload: Record<string, unknown>) =>
  http.post(`/messages/${id}/send`, payload).then((res) => res.data);

export const sendCustomerMessage = (id: string | number, message: string) =>
  http.post(`/customers/messages/${id}/send`, { message }).then((res) => res.data);

export const sendVendorMessage = (id: string | number, message: string) =>
  http.post(`/vendors/messages/${id}/send`, { message }).then((res) => res.data);
